import { ChartDataOptions, SideNavServiceOptions } from '../models/common.model';
import { GLOBAL_URL } from './dataServiceUrl';
import featureList from '../../config/featureList.json';
import PayerConfiguration from '../../modules/hospital/mailbox/PayerConfiguration';
import { CheckOutlined, CloseOutlined, EditOutlined, LoadingOutlined } from '@ant-design/icons';
import React, { ReactElement } from 'react';
import { Button, Spin, Switch, Tooltip } from 'antd';
import Text from 'antd/lib/typography/Text';
import { canActivate } from '../../utils/utility';
import { FinalClaimCancelModal, ReasonForCancellationModal } from '../../modules/crm/inPatient/detail/DeleteClaimChildComponents';
import { format } from 'date-fns';
import { ColorRange } from '../interfaces/tpaInterfaces';

export const NOTREQUIRED = 'N/A';

export const CHART_DATA: ChartDataOptions[] = [
  { title: 'First option', value: 10, color: '#e2e1ef' },
  { title: 'Second option', value: 15, color: '#8382ba' },
  { title: 'Third option', value: 20, color: '#56559a' },
];

export const authFeatureConstants: any = featureList;

export const DASHBOARD_TYPE_OPTIONS = [
  { value: 'Retails', label: 'Retails' },
  { value: 'Corporate', label: 'Corporate' },
];
export const MAIL_CONFIG = [
  {
    MailDomain: 'Gmail',
    IncomingMailServerPort: '993',
    IncomingMailServerHost: 'smtp.gmail.com',
    OutgoingMailServerPort: '587',
    OutgoingMailServerHost: 'smtp.gmail.com',
  },
  {
    MailDomain: 'Office365',
    IncomingMailServerPort: '993',
    IncomingMailServerHost: 'outlook.office365.com',
    OutgoingMailServerPort: '587',
    OutgoingMailServerHost: 'smtp.office365.com',
  },
  {
    MailDomain: 'HotMail',
    IncomingMailServerPort: '995',
    IncomingMailServerHost: 'outlook.office365.com',
    OutgoingMailServerPort: '587',
    OutgoingMailServerHost: 'smtp.office365.com',
  },
  {
    MailDomain: 'Microsoft Exchange',
    IncomingMailServerPort: '',
    IncomingMailServerHost: '',
    OutgoingMailServerPort: '',
    OutgoingMailServerHost: '',
  },
];

export const NAV_SERVICES: SideNavServiceOptions[] = [
  // {
  //   Name: 'Dashboard',
  //   Id: 'finance',
  //   Tabs: [],
  //   Icon: `${process.env.REACT_APP_COMMON_BUCKET_URL}svg-assets/i_dashboard.svg`,
  //   accessCheckKeyword: authFeatureConstants.DASHBOARD,
  // },
  {
    Name: 'Metrics Board',
    Id: 'metrics-board',
    Tabs: [],
    Icon: `${process.env.REACT_APP_COMMON_BUCKET_URL}svg-assets/i_dashboard.svg`,
    accessCheckKeyword: authFeatureConstants.METRICS_BOARD,
  },
  {
    Name: 'Claims',
    Id: 'claims',
    Tabs: ['Front Desk', 'In-Patient Desk'],
    Icon: `${process.env.REACT_APP_COMMON_BUCKET_URL}svg-assets/i_claims.svg`,
    accessCheckKeyword: authFeatureConstants.CLAIMS,
  },
  {
    Name: 'Reimbursement',
    Id: 'reimbursement',
    Tabs: [],
    Icon: `${process.env.REACT_APP_COMMON_BUCKET_URL}svg-assets/i_claims.svg`,
    accessCheckKeyword: authFeatureConstants.REIMBURSEMENT,
  },
  {
    Name: 'Nucleus Support',
    Id: 'grievance',
    Tabs: [],
    Icon: `${process.env.REACT_APP_COMMON_BUCKET_URL}svg-assets/grievance_icon.svg`,
    accessCheckKeyword: authFeatureConstants.GRIEVANCE,
  },
  {
    Name: 'Reconciliation',
    Id: 'reconciliation',
    Tabs: [],
    Updates: 'New',
    Icon: `${process.env.REACT_APP_COMMON_BUCKET_URL}svg-assets/i_reconciliation.svg`,
    accessCheckKeyword: authFeatureConstants.RECONCILIATION,
    left: '89px',
  },
  {
    Name: 'Corporate Claims',
    Id: 'corporate-funded-claims',
    Tabs: [],
    Updates: 'Upcoming',
    Icon: `${process.env.REACT_APP_COMMON_BUCKET_URL}svg-assets/Corp_Fund_Icon.svg`,
    accessCheckKeyword: NOTREQUIRED,
    left: '119px',
  },
  {
    Name: 'Government Claims',
    Id: 'government-funded-claims',
    Tabs: [],
    Updates: 'Upcoming',
    Icon: `${process.env.REACT_APP_COMMON_BUCKET_URL}svg-assets/Govt_Scheme_Icon.svg`,
    accessCheckKeyword: NOTREQUIRED,
    left: '138px',
  },
    {
    Name: 'Reporting and Analytics',
    Id: 'reporting-and-analytics',
    Tabs: [],
    Icon: `${process.env.REACT_APP_COMMON_BUCKET_URL}svg-assets/reports-and-analytics.svg`,
    accessCheckKeyword: authFeatureConstants.REPORT_ANALYTICS_MODULE,
  },
  {
    Name: 'HealthFlo (ABDM)',
    Id: 'abdm',
    Tabs: [],
    Icon: `${process.env.REACT_APP_COMMON_BUCKET_URL}svg-assets/i_abdm_hiu.svg`,
    accessCheckKeyword: authFeatureConstants.ABDM_HIU,
  },
  {
    Name: 'Onboarding Tab',
    Id: 'onboarding',
    Tabs: [],
    Icon: `${process.env.REACT_APP_COMMON_BUCKET_URL}svg-assets/i_onboarding.svg`,
    accessCheckKeyword: authFeatureConstants.ONBOARDING_TAB,
  },
  {
    Name: 'Cost Of Care',
    Id: 'cost-of-care',
    Tabs: [],
    Icon: `${process.env.REACT_APP_COMMON_BUCKET_URL}svg-assets/i_reconciliation.svg`,
    accessCheckKeyword: authFeatureConstants.COST_OF_CARE,
  },
  {
    Name: 'Profile',
    Id: 'profile',
    Tabs: ['Hospital Profile', 'Calendar', 'Documents'],
    Icon: `${process.env.REACT_APP_COMMON_BUCKET_URL}svg-assets/i_profile.svg`,
    accessCheckKeyword: authFeatureConstants.PROFILE,
  },
  {
    Name: 'Inventory',
    Id: 'inventory',
    Tabs: ['Hospital Seal', 'Doctors', 'Health C. Package', 'Lab Tests', 'IP Packages'],
    Icon: `${process.env.REACT_APP_COMMON_BUCKET_URL}svg-assets/i_inventory.svg`,
    accessCheckKeyword: authFeatureConstants.INVENTORY,
  },
  {
    Name: 'Help Center',
    Id: 'resources',
    Tabs: ['Guidelines', 'Help'],
    Icon: `${process.env.REACT_APP_COMMON_BUCKET_URL}svg-assets/i_helpcenter.svg`,
    accessCheckKeyword: authFeatureConstants.RESOURCES,
  },
  {
    Name: 'Claims Display',
    Id: 'claimsView',
    Tabs: [],
    Icon: `${process.env.REACT_APP_COMMON_BUCKET_URL}svg-assets/claims-display.svg`,
    accessCheckKeyword: authFeatureConstants.CLAIMS_DISPLAY,
  },
  {
    Name: 'Configurator',
    Id: 'configurator',
    Tabs: ['Ticker Configurator', 'Inbound IDs Configurator'],
    Icon: `${process.env.REACT_APP_COMMON_BUCKET_URL}svg-assets/Ticker_Icon_New.svg`,
    accessCheckKeyword: authFeatureConstants.CONFIGURATOR,
  },
];
export const ID: any = {
  ABHI:
  {
    'Member ID': 'Emp-memberId-card.png',
    'Employee ID': 'EmpId-card.png',
    'Policy No.': 'emp-policy-card.png',
  },
  RGI: {
    'Member ID': 'RGI - Member Card - Member ID Search.jpg',
    'Employee ID': 'RGI - Member Card - Employee ID Search.jpg',
    'Policy No.': 'RGI - Member Card - Policy Number Search.jpg',
  },
  HDFC: {
    'Policy No.': 'HDFC - Member Search - Policy Number Search.png', // IPP-4405-image-added-HDFC-Policy Search
  },
};
export const DATE_FORMAT = 'ddd, MMM DD, h:mm a';
export const DATE_FORMAT_WITHOUT_TIME = 'DD/MM/YY';
export const DATE_FORMAT_DD_MMMM_YYYY = 'dd MMMM yyyy';
export const DATE_FORMAT_MMMM_YYY = 'MMMM yyyy';
export const DATE_FORMAT_MM_DD_YYYY = 'MM/dd/yyyy';
export const UPC_DATE_FORMAT = 'D MMM YYYY';
export const UPC_TIME_FORMAT = 'hh:mm a';
export const DATE_FORMAT_DD_MMM_YYYY = 'dd/MMM/yyyy';
export const DATE_TIME_FORMAT = 'dd/MMM/yyyy hh:mm a';
export const ISO_8601_EXTENDED_FORMAT = 'yyyy-MM-dd\'T\'HH:mm:ss.SSSxxx';
export const MAIN_OPTIONS = [
  'profile', 'claims', 'reimbursement', 'grievance', 'resources', 'inventory', 'finance', 'metrics-board',
  'change-password', 'logout', 'jitsimeet', 'reconciliation', 'mailbox-configuration-response',
  'cost-of-care', 'abdm', 'claimsView', 'configurator', 'onboarding',
  'corporate-funded-claims', 'government-funded-claims', 'reporting-and-analytics',
];

export const GUTTOR_SPACE = 24;
export const GUTTOR_SPACE_SMALL = 16;
export const FETCH_ALL_FACILITY_TYPE = 'Custom/SearchLookUp/FacilityType';
export const FACILITY_GROUP_NAME = 'Facility';
export const SAVE_PROPERTY = 'Profile/SaveProperties';
export const STATUS_SUBMIT = 'SUBMIT';
export const STATUS_DRAFT = 'DRAFT';
export const APPLICATION_ID = 9233;
export const SAVE_DOCUMENT = 'Profile/SaveDocuments';
export const FILE_UPLOAD = 'File/Upload';
export const FETCH_FILE_BYTES = 'File/FetchFileBytes';
export const DOCUMENT_TYPE_INFRA_PHOTOS = 'InfraPhotos';
export const BANKDETAILS = 'Profile/FetchBankDetails';
export const BANKDETILSBYIFSC = 'Profile/FetchBankDetilsByIFSC/';
export const SAVEREGISTRATIONPANANDBANKDETAILS = 'Profile/SaveRegistrationPANAndBankDetails';
export const REGISTRATIONTYPE_HOSPITAL = 1054;
export const FETCHPROFILEDETAILS = 'Profile/FetchProfileDetails';
export const APPID = 9233;
export const ALPHABETS_REGEX = /^([a-zA-Z]){1,}([a-zA-Z\s])*$/;
export const NAME_REGEX = /^([a-zA-Z1-9]*[a-zA-Z- ]*[a-zA-Z]){1,}([a-zA-Z1-9._&,(')-\s])*$/;
export const PHR_REGEX = /^([a-zA-Z0-9\s]*(\.)?[a-zA-Z0-9\s]*)$/;
export const NAME_WITH_SPECIAL_CHARS = /^([a-zA-Z0-9]*[a-zA-Z- ]*[a-zA-Z]){1,}([a-zA-Z0-9.\\\/_/-\s])*$/;
export const NUMBER_REGEX = /^[\d]+$/;
export const PIN_CODE_REGEX = /^[\d]{6}$/;
export const GST_NO_REGEX = /^[A-Za-z\d]{15}$/;
export const PHONE_NUMBER_REGEX = /^(6|7|8|9){1}([\d]){9}$/;
export const PANCARD_REGEX = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
export const PANCARD_REGEX_NEW = /^([A-Z]){5}([0-9]){4}([A-Z]){1}?$/;
export const VOTER_ID = /^[A-Z]{3}[0-9]{7}$/;
export const WEBSITE_REGEX = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
export const IFSC_REGEX = /^[A-Za-z]{4}\d{7}$/;
export const NON_NAME_REGEX = /[^a-zA-Z\d .'\-]*/gm;
export const ONLY_ALPHA_NUMERIC = /[^a-zA-Z\d ]*/gm;
export const ONLY_ALPHABET = /[^a-zA-Z ]*/gm;
export const AADHAR_CARD_REGEX = /.{1,4}/g;
export const AADHAR_VALIDATOR = /^\d{4}\s\d{4}\s\d{4}$/;
export const COMMON_DATE_FORMAT = 'D MMM YYYY';
export const COMMON_TIME_FORMAT = 'hh:mm A';
export const HIS_COMMON_DATE_FORMAT = 'd MMM yyyy';
export const COMMON_TIME_SECONDS_FORMAT = 'hh:mm:ss';
export const MONTH_YEAR_DATE_FORMAT = 'MMM yyyy';
export const MESSAGE_TIMEOUT = 5;
export const MULTIPAYER_CONFIG_DELAY_THRESHOLD = 3;
export const HYPHEN_REGEX = /^([^-\n]*-){2,}[^-\n]*$/;
export const GHI_VALIDATION_REGEX = /^GHI\w*/;
export const BF_VALIDATION_REGEX = /^BF\w*/;
export const SPCL_CHARACTER = /[^a-zA-Z0-9]/g;
export const ALPHA_NUMERIC_REGEX = /^[a-z0-9]+$/i;
export const UPLOADED_ON_TIME_FORMAT = 'dd MMM yyyy';
export const INVALID_DATE = 'Invalid Date';
export const FONT_FAMILY_QUOTE_CLEANUP_REGEX = /^"(.*)"$/;
export const ONLY_NUMBER_REGEX = /[^0-9]+/g;
export const SINCE_WHEN_NUMBERS_AND_SPACES_REGEX = /[^0-9 ]+/g;

export const CAL_EVENTS_CATEGORY = [14020, 14007, 14006];

export const HOLIDAY_CAL_EVENT = 'holiday-cal-event';

export const SPECIAL_CAL_EVENT = 'special-cal-event';

export const NORMAL_CAL_EVENT = 'normal-cal-event';

export const INITIATED_ON_PLATFORM = 'Initiated on platform';

export const INDIAN_DATE_FORMAT = 'DD/MM/YYYY';
export const HEALTH_ADDRESS_REGEX = /^[a-zA-Z]+(([a-zA-Z.0-9]+){2})[a-zA-Z0-9]+@[a-zA-Z]+$/;
export const HEALTH_ID_REGEX = /^([0-9]{14})$|^[0-9]{2}[-][0-9]{4}[-][0-9]{4}[-][0-9]{4}$/;
export const POLICYNO_REGEX = /^(([a-zA-Z]{2,3}-[a-zA-Z\d]{2}-[a-zA-Z\d]{7})$|([a-zA-Z]{2,3}-[a-zA-Z\d]{2,3}-[a-zA-Z\d]{2,7}-[a-zA-Z\d]{2,11})$|([a-zA-Z 0-5 8-9]{2,4}-[a-zA-Z\d]{2,3}-[a-zA-Z\d]{2,7}-[a-zA-Z\d]{2,8}-[a-zA-Z\d]{2,9})$|([a-zA-Z\d]{14}))$/;
export const POLICY_NO_REGEX = /^[6,7]\d*/;
export const MEMBER_ID_NUMERICAL_REGEX = /^\d+$/;
export const MOBILE_MASK_REGEX = /^(\+91) (6|7|8|9){1}([\d]){2} ([\d]){4} ([\d]){3}/i;
export const MOBILE_MASK_REGEX_WITHOUT_PREFIX = /^(6|7|8|9){1}([\d]){2} ([\d]){4} ([\d]){3}/i;
export const MOBILENO_REPEAT_SEQUENCE_REGEX = /^\+91 (?!([6-9])\1{2} \1{4} \1{3})[6-9]\d{2} \d{4} \d{3}$/i;
export const POLICY_NO_REGEX_SPCL_CHARACTER = /^[a-zA-Z0-9\/\\_\-]+$/;
export const MASKHOSPITALNUMBER = 'MH999999999';
export const MASKADHAAR = '9999 9999 9999';
export const INPATIENT_MASK_REGEX = /^[I]{1}(\d)+$/;
export const CHOLA_POLICY_NUMBER_PATTERN = ['2842', '2868', '2876', '2887', '2891'];

export const PASSWORD_REGX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])(?=.{8,})/;
export const EMAIL_REGX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const MAX_CHARACTERS_LIMIT = 30;
export const PASSWORD_REQUIRED_MESSAGE = 'Please enter new password!';
export const VALIDATE_MESSAGES = {
  required: `\${label} is required!`,
  types: {
    email: `\${label} is not valid email!`,
  },
  string: {
    max: `\${label} cannot be longer than \${max} characters`,
    min: `\${label} must be at least \${min} characters`,
  },
};

export const PASSWORD_VALIDATION = [
  {
    regx: PASSWORD_REGX,
    errorMessage: 'Your password must contain',
  },
  {
    regx: /[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]+/,
    errorMessage: '- One special character.',
  },
  {
    regx: /[A-Z]+/,
    errorMessage: '- One uppercase letter.',
  },
  {
    regx: /[a-z]+/,
    errorMessage: '- One lowercase letter.',
  },
  {
    regx: /[0-9]+/,
    errorMessage: '- One number.',
  },
  {
    // No three or more identical characters in a row
    regx: /^(?!.*(.)\1{2,}).*$/,
    errorMessage: '- Password should not contain any 3 consecutive identical characters.',
  },
];

export const MIN_LENGTH_OF_PASSWORD = 12;
export const PREV_LOCATION_ARR_LENGTH = 3;
export const PASSWORD_MIN_LENGTH_MESSAGE = '- At least 12 characters.';
export const TYPEAHED_SEARCH_STRING_MIN_LENGTH = 4;

export const BLANK_ERROR_MESSAGE = {
  required: ``,
};

export const FETCH_DOCUMENTS = 'Profile/FetchDocuments';
export const FILE_DOWNLOAD = 'File/Download';
export const APPROVAL_TYPE = 'BOTH';
export const OPERATION = 'AND';
export const DATA_NOT_FOUND = 'No Data Found';
export const STATUS_DONE = 'done';
export const STATUS_REMOVED = 'removed';
export const APPROVED = 'approved';
export const VERIFIED = 'Verified';
export const IN_COMPLETE = 'Incomplete';
export const PENDING = 'Pending';
export const FILE_UPLOAD_TYPE = 'Report';
export const APPLICATION_ID_2 = '9214';
export const FILE_UPLOAD_SUCCESS = 'file uploaded successfully.';
export const FILE_UPLOAD_FAIL = 'file upload failed.';
export const UPLOAD_TITLE = 'Upload';
export const SAVE_SUCCESS = 'Saved Successfully';
export const SAVE_ERROR = 'Error Occured While Saving';
export const PAYER_NOT_CONFIGURED_ERR = 'Selected payer is not configured for your hospital. Please write to us at care@ihx.in.';
export const RPA_PAYER_NOT_CONFIGURED_ERR = 'Please enable the Payer in the manage payer section or Write to us at care@ihx.in';
export const NON_CONFIGURED_PAYERS_ERR = 'Unable to select this hospital, as no payers are configured for this.';
export const MAILBOX_PASSWORD_EXPIRED_ERROR = 'You cannot open this claim because your mailbox configuration is invalid. Please reconfigure to continue.';
export const POSTAL_CODE = 'postal_code';
export const FETCH_ALL_STATE = 'Custom/FetchAllState';
export const FETCH_SUB_GEO = 'Custom/FetchSubGeo';
export const SAVE_PROFILE = 'Profile/SaveProfile';
export const DOCUMENT_TYPE_SEARCH = 'Custom/FetchAllDocumentType';
export const INPATIENT_DATA = 'Provider/Search/ClaimsByActions';
export const CONTACT_TYPE_SEARCH = 'Custom/SearchLookUp/ContactType';
export const DEFAULT_GUID = '00000000-0000-0000-0000-000000000000';
export const CLAIMSUBMISSION_MESSAGE = 'Claim submission not allowed on Master Policy, please enter COI number or do a member ID search.';
export const POLICY_SEARCH_MESSAGE = `Please Enter a valid policy number with alphanumeric characters and only ${'/ \\\ - _'} characters.`;
export const POLICY_NOT_ELIGIBLE = 'Policy is not eligible for Cashless service at this hospital';
export const ROUTE_CHANGE_CONFIRMATION_MESSAGE = 'All the changes will be lost. Do you want to continue?';
export const ROUTE_CHANGE_DEFAULT_MESSAGE = 'Please Confirm';
export const ZERO_AMOUNT_VALIDATION_MESSAGE = 'A bill category cannot be Rs. 0.';
export const BILL_AMOUNT_VALIDATION_MESSAGE = 'Entered claimed amount is not matching with CSV total amount, kindly enter accurate amount.';
export const ENABLE_DISABLE_MESSAGE = 'Are you sure you want to disable?';
export const CSV_AMOUNT_INVALID = 'CSV AMOUNT INVALID';
export const DIALYSIS_ERR_MSG = 'Number of dialysis must be in between 1-20.';
export const DOADOD_INLINE_ERR_MSG = 'Date of discharge should be greater than or equal to date of admission.';
export const DOADOD_DAYCARE_ERR_MSG = 'Date of discharge should be 30 mins after date of admission.';
export const LENGTHOFSTAY_INLINE_ERR_MSG = 'Date of Discharge cannot exceed 6 months from Date of Admission selected';
export const ABHI_MEMBER_SEARCH_VALIDATION_MESSAGE = 'Policy Numbers are not allowed in member search fields.';
export const ABHI_MEMBER_SEARCH_ERR_MSG = 'Policy Numbers are not allowed in member search fields, try with Policy Search.';
export const ABHI_MEMBER_SEARCH_ERROR_MSG = 'Bajaj Finance Numbers are not allowed, please enter proper member ID.';
export const NUMBER_INPUT_ERR_MSG = 'Number must be in between 0-10.';
export const VALID_NUMBER_ERR_MSG = 'Enter the number in proper format (0-10).';
export const DEATHCASE_DOD_ERR_MSG = 'Date of discharge cannot not be greater than Today for Death Case';
export const MIN_CLAIM_AMOUNT_MESSAGE = 'Claim Amount must be greater than Rs.';
export const DEFAULT_BILL_DETAILS_TEXT = 'Enter total bill amount (without deducting/adjusting any discount)';

export const SETTLEMENT_DOD_ERR_MSG = 'Data shows that the patient is still in the hospital, update DOD for initiating settlement or click on "Edit" to enhance a claim request';
export const NOT_ELIGIBLE_INSURER_ERR = (insurerName?: any): any => {
  return insurerName ? `You are not part of ${insurerName}'s network. Kindly guide the client to raise a Reimbursement request to Medi Assist`
    : `You are not part of this insurer's network. Kindly guide the client to raise a Reimbursement request to Medi Assist`;
};
export const PASSWORD_NOT_VERIFIED_ERROR = 'Invalid Password. Please Reconfigure to continue';
export const CONSULTATION_TYPES = [
  { id: 1, value: 'Full-time', name: 'FullTime' },
  { id: 2, value: 'Part-time', name: 'PartTime' },
  // { id: 3, value: 'DC Visit' },
];
export const CURRENT_HASH = 'CURRENT_HASH';
export const VERSION_UPDATE_DATE = 'VERSION_UPDATE_DATE';
export const FETCH_PACKAGE = 'Inventory/FetchPackages';
export const PACKAGE_TYPE = {
  HEALTHCHECK: 'HealthCheck',
  LABTEST: 'LabTest',
  INPATIENT: 'InPatient',
};

export const GROUPED_ROLES = ['Group_admin', 'Cluster_Role', 'Vendor_Role'];

export const HEALTHCHECK_GENERAL_INCLUSIONS = [
  'Get enough sleep, at least 6 hours, prior to the check-up - Lack of sleep may cause abnormal results such as blood pressure, heart beat, and body temperature. The doctor may not be able to assess if any change is a real abnormality.',
  'Do not eat or drink at least 10 &ndash; 12 hours prior to the check-up. Do not chew gum, eat breath mints or consume other food substitutes during the fast time. Water, however may be freely taken to avoid dehydration effects on bd sugar and cholester  ol tests in the program.',
  'Please do not drink alcohol for at least 24 hours prior to appointment as alcohol may affect some tests. Please inform the doctor or nurse before the test.',
  'Kindly avoid smoking 5-12 hours prior to the health check-up',
  // tslint:disable-next-line: max-line-length
  'If you have a chronic illness or other health problems, please bring any test results or medical report with you to assist in diagnosis.',
  'Please bring your medical accessories like glasses, hearing aid if you have any when you come for Health Check Up.',
  'Please avoid wearing contact lenses and use Glasses on the day of health check',
  'Wear loose clothing, No jewellery (Necklaces / Chains) and easily removable footwear',
];
export const DEFAULT_PAGE_SIZE = 10;

export const DOCS_UPLOAD_NOTE = 'Only documents having start date and end date are being saved.!';
export const INVENTROY_CONSTANTS = {
  qualificationPresent: 'Qualification is already selected',
  qualificationCategoryPresent: 'Qualification category is already selected',
  profileSaveFail: 'Profile save failed due to some validations, please try again',
  consultation: 'Consultation',
  labTests: 'Lab Tests',
  doctor: 'Doctor',
  dayCare: 'DayCare',
  qual: 'qual',
  noDataFoundForFilter: 'No data found for selected filter',
  dep: 'dep',
  submit: 'SUBMIT',
  noDataFound: 'No data found',
  noCategoryFound: 'Categories for selected qualification not found',
  male: 'Male',
  female: 'Female',
  both: 'ThirdGender',
  personalDetails: 'Personal Details',
  professionalDetails: 'Professional Details',
  consultationDetails: 'Consultation Details',
  weeklySchedule: 'Weekly Schedule',
  profileDisableSuccess: 'Doctor profile disabled successfully',
  profileEnableSuccess: 'Doctor profile enabled successfully',
  profileDisableFail: 'Doctor profile disable failed',
  doctorList: '/doctor-list',
  doctorProfileRoute: '/doctor-profile/',
  editDoctorProfile: 'edit-doctor-profile',
  newDoctorProfile: 'new-doctor-profile',
  viewDoctorProfile: '/inventory/doctors/doctor-profile',
  doctorProfile: 'Doctor Profile',
  newDoctorProfileText: 'New Doctor Profile',
  editDoctorProfileText: 'Edit Doctor Profile',
  profileDetails: 'Profile Details',
  disableConfirmMessage: 'Do you want to stop appointments ?',
  enableConfirmMessage: 'Do you want to enable appointments ?',
  doctorName: 'Doctor name',
  department: 'Department',
  status: 'Status',
  filterBy: 'Filter by',
  enableMessage: 'You can enable profile by clicking inActive button',
  breakpointColumnsObj: {
    default: 3,
    1100: 3,
    700: 2,
    500: 1,
  },
  statusType_Submit: 'SUBMIT',
  packageType_InPatient: 'InPatient',
  ipPackagesRoute: '/ip-packages',
  editIpPackageRoute: '/edit-ip-package/',
  newIpPackageRoute: '/new-ip-package',
  ipPackageDetailRoute: '/ip-package-detail/',
  dayCarePackagesRoute: '/daycare-packages',
  editDayCarePackageRoute: '/edit-daycare-package/',
  newDayCarePackageRoute: '/new-daycare-package',
  daycarePackageDetailRoute: '/daycare-package-detail/',
  hcPackageDetailRoute: '/healthcheck-package-detail/',
  hcEditPackageRoute: '/edit-healthcheck-package/',
  hcPackageRoute: '/healthcheck-packages',
  hcNewPackageRoute: '/new-healthcheck-packages',
  profileMainRoute: '/profile',
  signature: 'Signature',
  upload_Text: 'Upload Doctor Signature',
  doctor_signature: 'DoctorSignature',
  FILE_NAME: 'Signature',
  patient_signature: 'PatientSignature',
};
export const INVENTORY_MESSAGE_CONSTANTS = {
  tryAgain: 'Please try again',
  packageRemoved: 'Package removed successfully',
  packageSaved: 'Package saved successfully',
  isRemovePackage: 'Do you want to stop appointments ?',
  roomsNotConfigured: 'Rooms not found. Please configure in hospital profile',
  errorOccurred: 'Error Occurred',
  selectDepartment: 'Please select department',
  selectProcedure: 'Please select procedure',
  enterDescription: 'Please enter package description',
  enterPrice: 'Please enter price',
  enterLengthOfStay: 'Please enter length of stay',
  isActivatePackage: 'Do you want to enable appointments ?',
  isDeActivatePackage: 'Do you want to stop appointments ?',
  enterDiscountPrice: 'Please enter discount price',
  packageDetailRequired: 'Package details are required, please save package detail first!',
  packageTest: 'Please provide the tests !!',
  packageConsulation: 'Please provide the consulations !!',
  packageSaveFail: 'Unable save package, please try again',
  departmentNotFound: 'Departments not found',
  consulationNotFound: 'Consulations not found',
  packageUpdateFail: 'Unable to update package, please try again',
  qualificationName: 'Please select the qualification',
  invalidTest: 'Please enter a valid test name',
  healthCheckNotConfigured: 'No healthcheck package configured',
  isActivatedSuccess: 'Package enabled successfully',
  isDeactivatedSuccess: 'Package disabled successfully',
  file_message: 'File format needs to be',
  file_format: ['.png', '.jpg', '.jpeg'],

  title: {
    editIp: 'Edit IP Package',
    newIp: 'New IP Package',
    ip: 'IP Packages',
    pricingDetails: 'Pricing Details',
    packageDetails: 'Package Details',
    healthCheckPackages: 'Health Check Packages',
    doctors: 'Doctors',
    dayCareSevices: 'Day Care Sevices',
  },
};

export const DOCTOR_GENDER: { [key: string]: string } = {
  Male: INVENTROY_CONSTANTS.male,
  Female: INVENTROY_CONSTANTS.female,
};

export const TWO_TONE_COLOR = '#3c3ada';
export const MSG_TIME = 3000;
export const DOCUMENT_TYPE_ROOM_PHOTOS = 'RoomPhotos';
export const ImageMaxSize = 10000000; // bytes
export const AcceptedFileTypes = 'image/x-png, image/png, image/jpg, image/jpeg, image/gif, image/jfif';
export const AcceptedFileTypesArray = AcceptedFileTypes
  .split(',')
  .map((item: string): string => {
    return item.trim();
  });
export const Base64Image = 'data:image/jpeg;base64,';

export const PROFILE_CONSTANTS = {
  hospitalProfile: 'Hospital Profile',
  profile: 'Profile',
  hospitalDocuments: 'Hospital Documents',
  document: 'Document',
};

export const DASHBOARD_DATA = [
  {
    title: PENDING,
    color: 'var(--chart_pending)',
    value: 0,
    key: 'ac',
  },
  {
    title: IN_COMPLETE,
    color: 'var(--chart_incomplete)',
    value: 0,
    key: 'ic',
  },
  {
    title: VERIFIED,
    color: 'var(--chart_verified)',
    value: 0,
    key: 'apc',
  },
];

export const NON_CLASSIFICATION_ERR = 'Not confirmed if mandatory documents are uploaded.';
export const LOGIN_ERROR = 'Something went wrong while login, please try again.';
export const COMMON_ERROR = 'Something went wrong! Please try again later.';
export const RESET_SUCCESS_MESSAGE = 'Password was successfully reset.';
export const RESET_MODAL_SUCCESS = 'Password reset link has been sent to your registered email ID.';
export const CAPTCHA_UNAVAILABILITY_ERROR = 'Unable to load CAPTCHA. Please Refresh.';
export const IDEAL_TIMEOUT_ERR = 'Your session timed out. Please login to continue.';
export const AMOUNT_GT_0_ERR = 'Amount must be greater than ₹ 0';
export const YEAR_0_ERR = 'The field value cannot be 00.0';
export const AMOUNT_MAXLIMIT_ERR = 'Amount must not be greater than ₹ 10,00,00,000';
export const VALID_YEAR_PATTERN = /^(0|0?[0-9]|[1-9][0-9])$/;
export const VALID_MONTH_PATTERN = /^(0|0?[0-9]|10|11)$/;

export const ABDM_HIP_NEW_CONSENT_COMMON_ERR = 'Unable to raise a consent. Please try again later';
export const ABDM_HIP_LIST_COMMON_ERR = 'Unable to fetch consent list. Please try again.';
export const ABDM_HIP_REGISTER_COMMON_ERR = 'Unable to register as an HIP. Please try again later.';
export const LINK_CONTEXT_FETCH_MODES_COMMON_ERR = 'Unable to get authentication modes. Please verify your ABHA address and try again';
export const GENERATE_OTP_ERR = 'Otp generation failed! Please try again.';
export const OTP_VERIFICATION_ERR = 'Otp verification failed. Please verify your health id';
export const MONTH_FORMAT_ERROR = 'Please enter a number between 0 and 11';
export const YEAR_FORMAT_ERROR = 'Please enter a number between 0 and 99';
export const TICKER_UPLOAD_SUCCESS = 'Ticker Message will be updated for the corresponding Providers. Please logout';
export const CSV_XLSX_WARNING = 'File type an only be XLSX or CSV';
export const INCORRECT_NAMING = 'The document name $%^%$%^&(.xlsx/.csv should not contain the special characters [ ! * \' ( ) ; : @ & = + $ , ? % # [ ]';
export const specialCharPattern = /[!*'();:@&=+$,?%#\[\]]/;
export const ALLOWED_FILE_TYPES_TICKER = ['csv', 'xlsx'];

export const StatusFilterType = {
  isSubmit: 'SUBMIT',
  isApproved: 'APPROVED',
  isRejected: 'REJECTED',
  isDefault: 'NA',
};
export const VALIDATION = {
  required: `Please Fill Out The Mandatory Fields.`,
};

export const DEFAULT_COORDINATES = {
  lat: 12.9739,
  lng: 77.5868,
};

export const EULA_Aggrement = `${GLOBAL_URL.REACT_APP_COMMON_BUCKET_URL}EULA_Agreement.html`;
export const EULA_PROPERTY_NAME = 'EULA';
export const PBI_DASHBOARD_TYPE = 'IHX_Finance_Provider';
export const FINANCE = 'Finance';

export const TOOLTIP_TEXT = {
  close: 'Close',
  add: 'Add',
  remove: 'Remove',
  edit: 'Edit',
  active: 'Active',
  inActive: 'In active',
  inActivate: 'In active',
  addWeeklyShcedule: 'Add weekly schedule',
  clearAll: 'Clear filters',
};
export const HELP_ROUTE = '/resources/guidelines';
export const DEFAULT_ROUTE = '/claims';
export const IHX_LOGO = `${GLOBAL_URL.REACT_APP_COMMON_BUCKET_URL}ihx-logo.png`;
export const REQUEST_PAYLOAD: any = {
  fetchContactDetail: true,
  fetchRegistrationDetail: true,
  fetchBankDetail: true,
  fetchRoom: true,
};
export const REQUEST_PAYLOAD_FOR_ROOM: any = {
  fetchRoom: true,
};
export const PAGE_QUERY_PARAM = '?page=';
export const DRAFT_CHANGE_STATUSES = {
  NO_CHANGE: 'NO_CHANGE',
  DRAFT_INITILIZING: 'DRAFT_INITILIZING',
  DRAFT_SAVED: 'DRAFT_SAVED',
};

export const SIGNUP_CAROUSEL = [
  {
    img: 'slide-9.svg',
    title: 'ABDM Compliance using HealthFlo',
    description: (
      <p>
        Help patients securely manage their health records.
        <br /> Digitally, anytime, anywhere.<br /> To know more, reach out to us at{' '}
        <u style={{ textDecoration: 'underline', color: 'blue' }}>abdm@ihx.in</u>
      </p>
    ),
  },
  {
    img: 'slide-7.svg',
    title: 'About',
    description: 'IHX Nucleus is the preferred Claims Management platform for the above listed Health Insurers and TPAs',
  },
  {
    img: 'slide-5.svg',
    title: 'Revenue Cycle Management',
    description: 'A solution that enables finance teams to view and download settlement and outstanding balances of Out-patient and     In-patient services',
  },
  {
    img: 'slide-6.svg',
    title: 'Database Security',
    description: 'The secured cloud-based platform ensures that patient data and billing information is secure and protected at all times',
  },
];
export const feverDays = ['1 day', '2 days', '3 days', '4 days', '> 4 days'];

export const NEWADMISSIONFOOTER_IMAGES = [
  {
    img: 'partners/HDFCImage.svg',
    title: 'HDFC Ergo General Insurance',
    description: 'Coming soon',
    descriptionClass: 'coming_soon',
    leftMargin: '45px',
    height: '40px',
  },
  {
    img: 'partners/Aditybirlaimage.svg',
    title: 'Aditya Birla Health Insurance',
    leftMargin: '45px',
    height: '40px',

  },
  {
    img: 'partners/mediassistimage.svg',
    title: 'Medi Assist<br />TPA',
    leftMargin: '50px',
    height: '45px',
  },
  {
    img: 'partners/MedVantageImage.svg',
    title: 'Medvantage<br /> TPA',
    description: 'New',
    descriptionClass: 'new',
    leftMargin: '51px',
    height: '40px',

  },
  {
    img: 'partners/RGIImage.svg',
    title: 'Reliance General Insurance',
    description: 'New',
    descriptionClass: 'new',
    leftMargin: '20px',
    height: '14px',
    top: '12px',
  },
  {
    img: 'partners/Raksha.png',
    title: 'Raksha<br /> TPA',
    description: 'New',
    descriptionClass: 'new',
    leftMargin: '51px',
    height: '40px',
  },
];
export const courierProviders = ['Delhivery Courier Services', 'DTDC Courier Company', 'Blue Dart Courier Service', 'Gati Shipping Partner', 'Professional Services', 'DHL', 'Ekart', 'Hand Delivery', 'Others'];
export const RELEASE_VERSION = 'Version: 25.09.02.01';
export const COPY_RIGHT_TEXT = `©${new Date().getFullYear()}, IHX Private Limited. All Rights Reserved.`;
export const IN_PATIENT_CONFIG_SELECT_ERR = `Minimum 6 and maximum 8 selection is allowed.`;
export const PREFERENCE_SAVE_FAIL_ERR = 'Unable to save preferences on server.';
export const CLAIMS_VIEW_CONFIG_SELECT_ERR = `Minimum 5 and maximum 6 selection is allowed`;
export const PARTNERSHIP_LETTER = `partnership_letter.pdf`;
export const IN_PATIENT_HORIZONTAL_CONFIG_SELECT_ERR = `Minimum 6 selection is allowed.`;

export const ALLOWED_MASTER_DATA_REFRESH_URL = [
  '/claims/in-patient',
  '/claims/updates',
  '/profile/hospital-profile/hospital-details',
  '/profile/calendar',
  '/profile/documents',
  '/profile/mailbox',
  '/profile/mailbox/rpaConfigure',
  '/inventory/doctors/doctors-list',
  '/inventory/health-check-package/healthcheck-packages',
  '/inventory/lab-tests/lab-tests',
  '/inventory/ip-packages/ip-packages',
  '/inventory/daycare-services/daycare-packages',
  '/resources/guidelines',
];

export const mailboxSideBodyComponents = {
  addPayer: PayerConfiguration,
};
export const getManagePayerColumns = (
  isEditing: any,
  edit: any,
  editingKey: any,
  onSaveRpa: any,
  onSaveAll: any,
  onCancel: any,
  onEnable: any,
  onEditAll: any,
  isEditSubmitted: boolean,
  isFirstEdit: boolean,
  isPayerConfigured: boolean,
  enableCheckSwitch: boolean,
  isEditAll: boolean,
  payerList: any[],
): any[] => {
  const colms: any = [
    {
      title: 'Payor Name',
      dataIndex: 'payerName',
      primaryDataIndex: 'payarID',
      key: 'payerName',
      editable: false,
      width: 300,
    },
    {
      title: 'Payor email ID',
      dataIndex: 'payerEmailID',
      primaryDataIndex: null,
      key: 'payerEmailID',
      editable: true,
      width: 280,
    },
    {
      title: 'Username',
      dataIndex: 'userName',
      primaryDataIndex: null,
      key: 'userName',
      editable: true,
      width: 160,
      render:
        (text: any, record: any): any => {
          return (
            record?.userName ?
              <span>{record?.userName}</span> : <span>-</span>
          );
        },
    },
    {
      title: 'Password',
      dataIndex: 'password',
      primaryDataIndex: null,
      key: 'password',
      editable: true,
      width: 160,
      render:
        (text: any, record: any): any => {
          return (
            record?.password ?
              <span>********</span> : <span>-</span>
          );
        },
    },
  ];
  if (canActivate(authFeatureConstants.EDIT_MAILBOX)) {
    colms.push(
      {
        title: !isFirstEdit ?
          'Actions' : (
            editingKey?.length === payerList?.length ?
              <><span className="mr-5 mouse-pointer text-primary">
                <span><CheckOutlined /></span>&nbsp;
                <span onClick={onSaveAll}>Save All</span>&nbsp;&nbsp;
              </span><span className="mr-5 mouse-pointer text-primary">
                  <span><CloseOutlined /></span>&nbsp;
                  <span onClick={onCancel}>Cancel</span>&nbsp;&nbsp;
                </span></> :
              <Button
                size="small"
                type="text"
                onClick={(): any => onEditAll()}>
                <strong>Edit All&nbsp;&nbsp;<EditOutlined /></strong>
              </Button>
          ),
        render: (text: any, record: any): any => {
          const editable = isEditing(record);
          return editable ? (
            isEditSubmitted ?
              (<Spin indicator={<LoadingOutlined />} />) :
              !isEditAll && (
                <div>
                  <span className="mr-5 mouse-pointer text-primary" onClick={(): any => onSaveRpa(record?.payerID, editable)}>
                    <span><CheckOutlined /></span>&nbsp;
                    <span>Save</span>
                  </span>
                  <span onClick={onCancel} className="mouse-pointer">
                    <Text type="secondary">Cancel</Text>
                  </span>
                </div>
              )
          ) : (
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <Button size="small" type="text" disabled={editingKey.length > 0} onClick={(): any => edit(record)}>
                <EditOutlined />
              </Button>
            </span>
          );
        },
      },
    );
    colms.push(
      {
        title: false ?
          'Enabled' : (
            <span className="mr-5 mouse-pointer text-primary">
              <span>Enabled</span>&nbsp;
            </span>
          ),
        render: (record: any): any => {
          return (
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <Tooltip title={(record?.userName === null && record?.password === null)
                && 'Enter username & password to enable/disable'}>
                <Switch size="small" onClick={(ev: any): any => onEnable(ev, record)} defaultChecked={record?.isEnabled}
                  disabled={(record?.userName === null && record?.password === null) ? true : false}
                />
              </Tooltip>
            </span>
          );
        },
      },
    );
  }
  return colms;
};
export const getMailboxCoulmns = (
  isEditing: any,
  edit: any,
  editingKey: any,
  onSave: any,
  onSaveAll: any,
  onCancel: any,
  onEnable: any,
  onEditAll: any,
  isEditSubmitted: boolean,
  isFirstEdit: boolean,
  isPayerConfigured: boolean,
  payerList: any[],
): any[] => {
  const colms: any = [
    {
      title: 'Payor Name',
      dataIndex: 'payerName',
      primaryDataIndex: 'payarID',
      key: 'payerName',
      editable: false,
      width: 400,
    },
    {
      title: 'Payor email ID',
      dataIndex: 'payerEmailID',
      primaryDataIndex: null,
      key: 'payerEmailID',
      editable: true,
      width: 300,
    },
  ];
  if (canActivate(authFeatureConstants.EDIT_MAILBOX)) {
    colms.push(
      {
        title: !isFirstEdit ?
          'Actions' : (
            editingKey?.length === payerList?.length ?
              <span className="mr-5 mouse-pointer text-primary">
                <span><CheckOutlined /></span>&nbsp;
                <span onClick={onSaveAll}>Save All</span>&nbsp;&nbsp;
              </span> :
              <Button
                size="small"
                type="text"
                onClick={(): any => onEditAll()}>
                <strong>Edit All&nbsp;&nbsp;<EditOutlined /></strong>
              </Button>
          ),
        render: (text: any, record: any): any => {
          const editable = isEditing(record);
          return editable ? (
            isEditSubmitted ?
              (<Spin indicator={<LoadingOutlined />} />) :
              (!isFirstEdit ? (<div>
                <span className="mr-5 mouse-pointer text-primary" onClick={(): any => onSave(record?.payerConfigurationID)}>
                  <span><CheckOutlined /></span>&nbsp;
                  <span>Save</span>
                </span>
                <span onClick={onCancel} className="mouse-pointer">
                  <Text type="secondary">Cancel</Text>
                </span>
              </div>) : <></>)
          ) : (
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <Button size="small" type="text" disabled={editingKey.length > 0} onClick={(): any => edit(record)}>
                <EditOutlined />
              </Button>
            </span>
          );
        },
      },
    );
    colms.push(
      {
        title: !isFirstEdit ?
          'Enabled' : (
            <span className="mr-5 mouse-pointer text-primary">
              <span>Enabled</span>&nbsp;
            </span>
          ),
        render: (record: any): any => {
          return (
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              {/* Added disabled prop to Switch button */}
              <Switch size="small" defaultChecked={record.isEnabled}
                disabled={editingKey.length > 0} onClick={(ev: any): any => onEnable(ev, record)} />
            </span>
          );
        },
      },
    );
  }
  return colms;
};

export const PASSWORD_EXPIRED_ERROR = 'Your Password Expired, change password';
export const DELAYED_POPUP_MSG_DOD = 'The length of stay entered for the patient is exceeding 90 days. Please enter the reason for the extended length of stay.';
export const ROOM_RENT_WITH_ADDITIONAL_FIELD_WARNING = 'Please enter two or more bill categories for non-packaged claims';
export const HEALTH_ID_ERROR_MESSAGE = 'Please enter valid healthId!';
export const AADHAR_NUMBER_ERROR_MESSAGE = 'Please enter valid Aadhar number!';
export const PAN_CARD_NUMBER_ERROR_MESSAGE = 'Please enter valid Pan Card number!';
export const VOTER_ID_ERROR_MESSAGE = 'Please enter valid Voter Id!';

export const ALLOWED_FILE_TYPES = {
  'LABEL': ['.pdf', '.png', '.jpg', '.jpeg', '.xls', '.xlsx', '.csv', '.json'],
  'INPATIENT_SUBFILTER_UPLOAD_FILES': ['.csv, .xlsx, .xlx'],
  'TYPES': [
    'image/png',
    'image/jpg',
    'image/jpeg',
    'application/pdf',
    'application/json',
    'text/csv',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
    'application/msword',
  ],
  'BUDDHIMED_CALL_RESTRICT_TYPES': [
    'application/json',
    'text/csv',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
  ],
};
export const CASHLESS_PDF_DOWNLOAD_SUCCESS_MESSAGE = 'Cashless form downloaded successfully!';
export const CHECKLIST_PDF_DOWNLOAD_SUCCESS_MESSAGE = 'Checklist form downloaded successfully!';
export const ACKNOWLEDGEMENT_PDF_DOWNLOAD_SUCCESS_MESSAGE = 'Acknowledgement letter downloaded successfully!';

export const NEW_ADMISSION_DOWNLOAD_ACTIONS = [
  { key: 'cashlessForm', name: 'Cashless Form' },
  { key: 'checklistForm', name: 'Checklist Form' },
  { key: 'acknowledgementLetter', name: 'Acknowledgement Letter' },
];
export const AUTOMATION_SIMULATION_MEMBER_ID = 'PT00430258';
export const AUTOMATION_SIMULATION_PAYER = 'Aditya Birla Health Insurance Co. Limited';
export const AUTOMATION_SIMULATION_PAYER_ID = 516571;
export const AUTOMATION_SIMULATION_HOSPITAL = 522228;

export const PROD_AUTOMATION_SIMULATION = {
  'HOSPITALS': [523385, 524900],
  'MEMBER_ID': 'PT00430258',
  'POLICY_NO': 'XYZ-71-22-0014147-000-000',
};

export const NHCX_ROLES = {
  'PROVIDER': '10001',
  'PAYER': '10002',
  'AGENCY_TPA': '10003',
  'AGENCY_REGULATOR': '10004',
  'RESEARCH': '10005',
  'MEMBER_ISNP': '10006',
  'AGENCY_SPONSOR': '10007',
  'HIE_HIO_HCX': '10008',
};

export const NHCX_REGISTRIES = {
  'HFR': ['10001'],
  'NIN': ['10002'],
  'ROHINI': ['10003'],
  'PAYER': ['10004'],
};

export const DaycareColumns = [
  {
    title: 'Active',
  },
  {
    title: 'Name',
  },
  {
    title: 'Department',
  },
  {
    title: 'Sessions',
  },
  {
    title: 'PriceRange',
  },
  {
    title: 'Status',
  },
];

export const IPPackageListColumns = [
  {
    title: 'Active',
  },
  {
    title: 'Name',
  },
  {
    title: 'Department',
  },
  {
    title: 'Price Range',
  },
  {
    title: 'Status',
  },
];

export const HealthcheckpackageColumns = [
  {
    title: 'Active',
  },
  {
    title: 'Name',
  },
  {
    title: 'Age-Range',
  },
  {
    title: 'Price',
  },
  {
    title: 'Status',
  },
  {
    title: 'LastUpdated',
  },
];
export const VIDAL_DYNAMIC_TREATMENT_DETAILS_JSON: any = {
  hospitalizationReason: {
    'Injury': ['dateOfInjury', 'reasonForInjury'],
    'Maternity': ['noOfAdoptedChildren', 'noOfBiologicalChildren', 'noOfDeliveries', 'dateOfSurgery'],
  },
  systemOfMedicine: {
    'Ayush': ['subGroup'],
  },
  conditionOnDischarge: {
    'Expired': ['dateOfExpiry'],
    'Alive': ['permanentDisability'],
  },
  reasonForInjury: {
    'Accident': ['accidentDueTo', 'isMLC', 'permanentDisability'],
  },
  proposedLineOfTreatment: {
    '311174': ['dateOfSurgery', 'cataractOperatedFor', 'surgeryType'],
    'Surgical': ['dateOfSurgery', 'cataractOperatedFor', 'surgeryType'],
  },
  typeOfMaternity: {
    'New Born Baby': ['dobOfChild', 'vaccinationDate'],
    'Twin/Triplet Delivery': ['typeOfDelivery'],
  },
};

export const GO_DIGIT_DYNAMIC_TREATMENT_DETAILS_JSON: any = {
  hospitalizationReason: {
    'Illness': ['presentComplaints'],
  },
};

export const GO_DIGIT_MATERNITY_TYPE_OPTIONS = ['Normal Delivery', 'Assisted delivery', 'Caesarian'];

export const MATERNITY_TYPE_OPTIONS = ['Normal Delivery', 'LSCS Delivery', 'Induced Abortion (MTP)', 'Spontaneous Abortion',
  'New Born Baby', 'Post Natal Admission', 'Pre Natal Admission', 'Twin & Triplet Delivery'];

export const FILTER_KEY_FOR_IPO = 'IPO';
export const FILTER_KEY_FOR_COVERAGE = 'MEMBERSEARCH';

export const speciailityOptions = [
  { 'id': '1', 'value': 'Allopathy' },
  { 'id': '2', 'value': 'Dentistry' },
  { 'id': '3', 'value': 'Physiotherapy' },
  { 'id': '4', 'value': 'Ayurveda' },
  { 'id': '5', 'value': 'Unani' },
  { 'id': '6', 'value': 'Siddha' },
  { 'id': '7', 'value': 'Sowa-Rigpa' },
  { 'id': '8', 'value': 'Homeopathy' }];
export const facilityOptions = [
  { 'id': '1', 'value': 'Government' },
  { 'id': '2', 'value': 'Private' },
  { 'id': '3', 'value': 'Public-Private Partnership' },
];
export const facilitySubTypeOptions = [
  { 'id': '1', 'value': 'For profit' },
  { 'id': '2', 'value': 'Not-for-profit' },
];
export const facilityTypeOptions = [
  { 'id': '1', 'value': ' Medical College' },
  { 'id': '2', 'value': 'Hospital' },
  { 'id': '3', 'value': 'Clinic/Dispensary' },
  { 'id': '4', 'value': 'Blood Bank' },
  { 'id': '5', 'value': 'Diagnostic Laboratory' },
  { 'id': '6', 'value': 'Imaging Centre' },
  { 'id': '7', 'value': 'Cath Laboratory' },
  { 'id': '8', 'value': 'Dialsysis Centre' },
];
export const facilitySubOptions = [
  { 'id': '1', 'value': 'No Applicable' },
  { 'id': '2', 'value': 'Civil Hospital' },
  { 'id': '3', 'value': 'Daycare Centre' },
  { 'id': '4', 'value': 'General Hospital' },
  { 'id': '5', 'value': 'Leprosy Hospital' },
];
export const fileOptions = ['Biomedical waste certificate', 'Fire fitness certificate', 'Cancelled Cheque',
  'NABH accreditation certificate',
  'Registration certificate', 'GSTIN Certificate',
  'State specific provider registration certificate',
  'Mandate form (to be downloaded, duly filled, and uploaded on HEM)'];
export const heritageCanellationOptions = ['Admission date changed', 'Wrong member selected', 'Patient not availed cashless', 'Others'];

export const createTimelineItems = (
  fieldCompletion: any,
  flowCompleted: React.ReactElement,
  flowIncomplete: React.ReactElement,
): any => [
    {
      text: 'Enter Health Facility Registry (HFR) ID',
      icon: <>1</>,
      completed: fieldCompletion?.hfrId,
    },
    {
      text: 'Enter mobile number registered in HFR',
      icon: <>2</>,
      completed: fieldCompletion?.mobileNumber,
    },
    {
      text: 'Enter hospital email ID registered in HFR',
      icon: <>3</>,
      completed: fieldCompletion?.email,
    },
    {
      text: 'Enter the passcode sent to mobile\n number registered in HFR',
      icon: <>4</>,
      completed: fieldCompletion?.otp,
    },
    {
      text: 'Participation in NHCX created successfully',
      icon: fieldCompletion?.verification ? flowCompleted : flowIncomplete,
    },
  ];

  export const createGuidelineItems = (
    searchType: string,
    fieldCompletion: any,
  ): any => {
    switch (searchType) {
      case 'HIS':
        return [
          {
            key: 'searchActivation',
            title: 'HIS Search Activation',
            description: 'Activate or deactivate the toggle based on preference',
            step: 1,
            active: false,
            completed: fieldCompletion?.searchActivation,
            header: 'Select Patient Search Method',
          },
          {
            key: 'patientCard',
            title: 'Patient Search in HIS',
            description: 'Enter patient identifier to retrieve visit cards and select the valid card',
            step: 2,
            active: false,
            completed: fieldCompletion?.patientCard,
            header: 'Select Patient Visit Card to Continue',
          },
          {
            key: 'memberOrPolicy',
            title: 'Select Member/ Policy Search Option',
            description: 'Choose between Insurance/TPA or NHCX (Policy Search) to proceed with claim submission',
            step: 3,
            active: false,
            completed: fieldCompletion?.memberOrPolicy,
            header: 'Select Member/ Policy Search Option',
          },
          {
            key: 'policyCard',
            title: 'Policy Search in NHCX',
            description: 'Enter Patient ABHA ID or Mobile Number to search the policy. Select & Proceed',
            step: 4,
            active: false,
            completed: fieldCompletion?.policyCard,
            header: 'Select Policy Card to continue',
          },
          {
            key: 'memberSearch',
            title: 'Member Search in Payer System',
            description: 'Autofill and locate the member based on the chosen policy',
            step: 5,
            active: false,
            completed: fieldCompletion?.memberSearch,
            header: 'Select Member on Payer System',
            subStep: {
              key: 'memberCard',
              step: 6,
              active: false,
              completed: fieldCompletion?.memberCard,
              header: 'Select Member Card to Continue',
            },
          },
          {
            key: 'claimReviewed',
            title: 'Review Claim Form',
            description: 'Review auto-filled claim form details from HIS and NHCX',
            step: 7,
            active: false,
            completed: fieldCompletion?.claimReviewed,
            header: 'Review Claim Form',
          },
          {
            key: 'documentsAttached',
            title: 'Document Attachment',
            description: 'Attach available documents from HIS or upload additional ones',
            step: 8,
            active: false,
            completed: fieldCompletion?.documentsAttached,
            header: 'Attach Documents for Claim Submission',
          },
          {
            key: 'submitClaim',
            title: 'Final Review and Submission',
            description: 'Verify, Correct or Retry if necessary before submitting the claim form',
            step: 9,
            active: false,
            completed: fieldCompletion?.submitClaim,
            header: 'Final Review and Submission',
          },
        ];
      case 'NHCX':
        return [
          {
            key: 'memberOrPolicy',
            title: 'Policy Search in NHCX',
            description: 'Enter Patient ABHA ID or Mobile Number to search the policy. Select & Proceed',
            step: 1,
            active: false,
            completed: fieldCompletion?.memberOrPolicy,
            header: 'Policy Search in NHCX',
            subStep: {
              key: 'policyCard',
              step: 2,
              active: false,
              completed: fieldCompletion?.policyCard,
              header: 'Select Policy Card to Continue',
            },
          },
          {
            key: 'memberSearch',
            title: 'Member search in Payer System',
            description: 'Autofill and locate the member based on the chosen policy',
            step: 3,
            active: false,
            completed: fieldCompletion?.memberSearch,
            header: 'Select Member on Payer System',
            subStep: {
              key: 'memberCard',
              step: 4,
              active: false,
              completed: fieldCompletion?.memberCard,
              header: 'Select Member Card to Continue',
            },
          },
          {
            key: 'claimReviewed',
            title: 'Review Claim Form',
            description: 'Review auto-filled claim form details from HIS and NHCX',
            step: 5,
            active: false,
            completed: fieldCompletion?.claimReviewed,
            header: 'Review Claim Form',
          },
          {
            key: 'documentsAttached',
            title: 'Document Attachment',
            description: 'Attach available documents from HIS or upload additional ones',
            step: 6,
            active: false,
            completed: fieldCompletion?.documentsAttached,
            header: 'Attach Documents for Claim Submission',
          },
          {
            key: 'submitClaim',
            title: 'Final Review and Submission',
            description: 'Verify, Correct or Retry if necessary before submitting the claim form',
            step: 7,
            active: false,
            completed: fieldCompletion?.submitClaim,
            header: 'Final Review and Submission',
          },
        ];
        case 'HIS-W/O-NHCX':
          return [
            {
              key: 'searchActivation',
              title: 'HIS Search Activation',
              description: 'Activate or deactivate the toggle based on preference',
              step: 1,
              active: false,
              completed: fieldCompletion?.searchActivation,
              header: 'Select Patient Search Method',
            },
            {
              key: 'patientCard',
              title: 'Patient Search in HIS',
              description: 'Enter patient identifier to retrieve visit cards and select the valid card',
              step: 2,
              active: false,
              completed: fieldCompletion?.patientCard,
              header: 'Select Patient Visit Card to Continue',
            },
            {
              key: 'memberOrPolicy',
              title: 'Select Member/ Policy Search Option',
              description: 'Choose between Insurance/TPA or NHCX (Policy Search) to proceed with claim submission',
              step: 3,
              active: false,
              completed: fieldCompletion?.memberOrPolicy,
              header: 'Select Member/ Policy Search Option',
            },
            {
              key: 'memberSearch',
              title: 'Member Search in Payer System',
              description: 'Search the member using Member ID, Employee ID or Policy No',
              step: 4,
              active: false,
              completed: fieldCompletion?.memberSearch,
              header: 'Select the Right Member card',
            },
            {
              key: 'claimReviewed',
              title: 'Review Claim Form',
              description: 'Review auto-filled claim form details from HIS and NHCX',
              step: 5,
              active: false,
              completed: fieldCompletion?.claimReviewed,
              header: 'Review Claim Form',
            },
            {
              key: 'documentsAttached',
              title: 'Document Attachment',
              description: 'Attach available documents from HIS or upload additional ones',
              step: 6,
              active: false,
              completed: fieldCompletion?.documentsAttached,
              header: 'Attach Documents for Claim Submission',
            },
            {
              key: 'submitClaim',
              title: 'Final Review and Submission',
              description: 'Verify, Correct or Retry if necessary before submitting the claim form',
              step: 7,
              active: false,
              completed: fieldCompletion?.submitClaim,
              header: 'Final Review and Submission',
            },
          ];
      default:
        return [
          {
            key: 'memberSearch',
            title: 'Member search in Payer System',
            description: 'Search the member using Member ID, Employee ID or Policy No',
            step: 1,
            active: false,
            completed: fieldCompletion?.memberSearch,
            header: 'Search Member on Payer System',
            subStep: {
              key: 'memberCard',
              step: 2,
              active: false,
              completed: fieldCompletion?.memberCard,
              header: 'Select the Right Member Card',
            },
          },
          {
            key: 'claimReviewed',
            title: 'Review Claim Form',
            description: 'Select the member card, review auto-filled member details',
            step: 3,
            active: false,
            completed: fieldCompletion?.claimReviewed,
            header: 'Review Claim Form',
          },
          {
            key: 'documentsAttached',
            title: 'Document Attachment',
            description: 'Upload required documents to the claim form',
            step: 4,
            active: false,
            completed: fieldCompletion?.documentsAttached,
            header: 'Attach Documents for Claim Submission',
          },
          {
            key: 'submitClaim',
            title: 'Final Review and Submission',
            description: 'Verify, Correct or Retry if necessary before submitting the claim form',
            step: 5,
            active: false,
            completed: fieldCompletion?.submitClaim,
            header: 'Final Review and Submission',
          },
        ];
      }
    };

export const createOnMailGuidelineItems = (
  searchType: string,
  fieldCompletion: any,
): any => {
  switch (searchType) {
    case 'HIS':
      return [
        {
          key: 'searchActivation',
          title: 'HIS Search Activation',
          description: 'Activate or deactivate the toggle based on preference',
          step: 1,
          active: false,
          completed: fieldCompletion?.searchActivation,
          header: 'Select Patient Search Method',
        },
        {
          key: 'patientCard',
          title: 'Patient Search in HIS',
          description: 'Enter patient identifier to retrieve visit cards and select the valid card',
          step: 2,
          active: false,
          completed: fieldCompletion?.patientCard,
          header: 'Select Patient Visit Card to Continue',
        },
        {
          key: 'memberOrPolicy',
          title: 'Select Member/ Policy Search Option',
          description: 'Choose between Insurance/TPA or NHCX (Policy Search) to proceed with claim submission',
          step: 3,
          active: false,
          completed: fieldCompletion?.memberOrPolicy,
          header: 'Select Member/ Policy Search Option',
        },
        {
          key: 'policyCard',
          title: 'Policy Search in NHCX',
          description: 'Enter Patient ABHA ID or Mobile Number to search the policy. Select & Proceed',
          step: 4,
          active: false,
          completed: fieldCompletion?.policyCard,
          header: 'Select Policy Card to continue',
        },
        {
          key: 'claimReviewed',
          title: 'Review Claim Form',
          description: 'Review auto-filled claim form details from HIS and NHCX',
          step: 5,
          active: false,
          completed: fieldCompletion?.claimReviewed,
          header: 'Review Claim Form',
        },
        {
          key: 'documentsAttached',
          title: 'Document Attachment',
          description: 'Attach available documents from HIS or upload additional ones',
          step: 6,
          active: false,
          completed: fieldCompletion?.documentsAttached,
          header: 'Attach Documents for Claim Submission',
        },
        {
          key: 'submitClaim',
          title: 'Final Review and Submission',
          description: 'Verify, Correct or Retry if necessary before submitting the claim form',
          step: 7,
          active: false,
          completed: fieldCompletion?.submitClaim,
          header: 'Final Review and Submission',
        },
      ];
    case 'NHCX':
      return [
        {
          key: 'memberOrPolicy',
          title: 'Policy Search in NHCX',
          description: 'Enter Patient ABHA ID or Mobile Number to search the policy. Select & Proceed',
          step: 1,
          active: false,
          completed: fieldCompletion?.memberOrPolicy,
          header: 'Policy Search in NHCX',
          subStep: {
            key: 'policyCard',
            step: 2,
            active: false,
            completed: fieldCompletion?.policyCard,
            header: 'Select Policy Card to Continue',
          },
        },
        {
          key: 'claimReviewed',
          title: 'Review Claim Form',
          description: 'Review auto-filled claim form details from NHCX',
          step: 3,
          active: false,
          completed: fieldCompletion?.claimReviewed,
          header: 'Review Claim Form',
        },
        {
          key: 'documentsAttached',
          title: 'Document Attachment',
          description: 'Upload required documents to the claim form',
          step: 4,
          active: false,
          completed: fieldCompletion?.documentsAttached,
          header: 'Attach Documents for Claim Submission',
        },
        {
          key: 'submitClaim',
          title: 'Final Review and Submission',
          description: 'Verify, Correct or Retry if necessary before submitting the claim form',
          step: 5,
          active: false,
          completed: fieldCompletion?.submitClaim,
          header: 'Final Review and Submission',
        },
      ];
    case 'HIS-W/O-NHCX':
      return [
        {
          key: 'searchActivation',
          title: 'HIS Search Activation',
          description: 'Activate or deactivate the toggle based on preference',
          step: 1,
          active: false,
          completed: fieldCompletion?.searchActivation,
          header: 'Select Patient Search Method',
        },
        {
          key: 'patientCard',
          title: 'Patient Search in HIS',
          description: 'Enter patient identifier to retrieve visit cards and select the valid card',
          step: 2,
          active: false,
          completed: fieldCompletion?.patientCard,
          header: 'Select Patient Visit Card to Continue',
        },
        {
          key: 'memberOrPolicy',
          title: 'Select Member/ Policy Search Option',
          description: 'Choose between Insurance/TPA or NHCX (Policy Search) to proceed with claim submission',
          step: 3,
          active: false,
          completed: fieldCompletion?.memberOrPolicy,
          header: 'Select Member/ Policy Search Option',
        },
        {
          key: 'claimReviewed',
          title: 'Review Claim Form',
          description: 'Review auto-filled claim form details',
          step: 4,
          active: false,
          completed: fieldCompletion?.claimReviewed,
          header: 'Review Claim Form',
        },
        {
          key: 'documentsAttached',
          title: 'Document Attachment',
          description: 'Attach available documents from HIS or upload additional ones',
          step: 5,
          active: false,
          completed: fieldCompletion?.documentsAttached,
          header: 'Attach Documents for Claim Submission',
        },
        {
          key: 'submitClaim',
          title: 'Final Review and Submission',
          description: 'Verify, Correct or Retry if necessary before submitting the claim form',
          step: 6,
          active: false,
          completed: fieldCompletion?.submitClaim,
          header: 'Final Review and Submission',
        },
      ];
    default:
      return [
        {
          key: 'memberSearch',
          title: 'Select the Payer',
          description: 'Choose the appropriate payer from the dropdown menu',
          step: 1,
          active: false,
          completed: fieldCompletion?.memberSearch,
          header: 'Search Member on Payer System',
        },
        {
          key: 'claimReviewed',
          title: 'Review Claim Form',
          description: 'Enter the required patient,treatment and bill details',
          step: 2,
          active: false,
          completed: fieldCompletion?.claimReviewed,
          header: 'Review Claim Form',
        },
        {
          key: 'documentsAttached',
          title: 'Document Attachment',
          description: 'Upload required documents to the claim form',
          step: 3,
          active: false,
          completed: fieldCompletion?.documentsAttached,
          header: 'Attach Documents for Claim Submission',
        },
        {
          key: 'submitClaim',
          title: 'Final Review and Submission',
          description: 'Verify, Correct or Retry if necessary before submitting the claim form',
          step: 4,
          active: false,
          completed: fieldCompletion?.submitClaim,
          header: 'Final Review and Submission',
        },
      ];
  }
};

export const ALPHA_NUMERIC_VALIDATION = 'Please enter only alphanumeric characters with a length of 10 characters';
export const formatMobileNumber = (mobileNumber: any): any => {
  const mobNo = mobileNumber?.replace(/\D/g, '');
  // Format into XXX XXXX XXX
  return `${mobNo?.slice(0, 3)} ${mobNo?.slice(3, 7)} ${mobNo?.slice(7)}`;
};

export const CANCEL_WITHOUT_DOCS_FLOW = [
  {
    title: 'Claim Cancellation',
    component: ReasonForCancellationModal,
    buttonText: 'Submit',
    modalWidth: 430,
    backFn: false,
  },
];

export const CARE_CANCEL_FLOW = [
  {
    title: 'Claim Cancellation',
    component: ReasonForCancellationModal,
    buttonText: 'Next',
    modalWidth: 430,
    backFn: false,
  },
  {
    title: 'Claim Cancellation',
    component: FinalClaimCancelModal,
    modalWidth: 750,
    backFn: true,
  },
];

export const NON_HIS_CARE_CANCEL_FLOW = [
  {
    title: 'Claim Cancellation',
    component: ReasonForCancellationModal,
    buttonText: 'Next',
    modalWidth: 430,
    backFn: false,
  },
  {
    title: 'Claim Cancellation',
    component: FinalClaimCancelModal,
    modalWidth: 850,
    backFn: true,
  },
];

export const HIS_CARE_CANCEL_FLOW = [
  {
    title: 'Claim Cancellation',
    component: ReasonForCancellationModal,
    buttonText: 'Next',
    modalWidth: 430,
    backFn: false,
  },
  {
    title: 'Claim Cancellation',
    component: FinalClaimCancelModal,
    modalWidth: 850,
    backFn: true,
  },
];

export const CANCEL_FLOW = [
  {
    title: 'Claim Cancellation',
    component: FinalClaimCancelModal,
    modalWidth: 750,
    backFn: false,
  },
];

export const NON_HIS_CANCEL_FLOW = [
  {
    title: 'Claim Cancellation',
    component: FinalClaimCancelModal,
    modalWidth: 850,
    backFn: false,
  },
];

export const HIS_CANCEL_FLOW = [
  {
    title: 'Claim Cancellation',
    component: FinalClaimCancelModal,
    modalWidth: 850,
    backFn: false,
  },
];

export const maxLength = 14;
export const HIS_VALUE_MAX_LENGTH = 14;
export const WRAP_IN_DIV_FOR = ['diagnosis', 'isDischargeCase', 'diagnosisDropDown',
  'testConductedToEstablishedThis', 'injuryOrDeseaseCaused', 'isDeathCase',
  'isItARta', 'isReportedToPolice', 'procedure', 'procedureDropDown', 'panNumber',
];

export const KEYS_TO_DIV_HIS_VALUES = ['diagnosis', 'diagnosisDropDown', 'procedure', 'procedureDropDown', 'ailment'];

export const validIds = [3, 8, 10, 13, 6, 54, 53, 43, 41, 52, 58];

export const MAX_TICKERS = 3;

export const PARTICIPANT_ID_EXISTING = 'PARTICIPANT ID WAS ALREADY CREATED';

export const SYNC_MESSAGE = 'The status will be updated within 2-3 minutes. Please refresh the page to see the latest status received from the Payer.';

export const EXCHANGE_URL = '/EWS/Exchange.asmx';

export const HTTP_EXCEPTION = 'https://';

export const MICROSOFT_EXCHANGE_URL = 'Sample format: <your_server_name>/EWS/Exchange.asmx';

// showing policy note based on Payers
export const POLICY_NOTE: any = {
  HDFC: 'Note: **Benefits may vary. Kindly refer policy document for more details.',
};
export const GROUP_POLICY_HDFC = `Note: "This is a Combi Policy. If you selected a top-up policy, ensure the base policy's sum insured is fully consumed. Otherwise, first submit the claim under the base policy"`;
export const DEFAULT_DOD_TIME = '11:00 PM';

export const RANDOM_GENERATED_TOKEN_V2 = 'akndkandknakdsnkandkandas=/adjabdjandkjandk';
export const RECONDIDERATION_DEFAULT_CONFIRM = 'You can only ask for a claim reconsideration once per claim. After you submit, this option is used up. Please upload all necessary documents and a letter explaining why you want the reconsideration to help avoid rejections.';

export const NO_DOCUMENTS_AVAILABLE_IN_HIS_SYSTEM = 'There are no documents available in the HIS System. Try uploading the file manually.';

export const DEFAULT_MAX_FILE_SIZE = 15 * 1024 * 1024;

export const MAX_FILES = 5;

export const cancelFlowMap = {
  CANCEL_FLOW_WITHOUT_DOCS: CANCEL_WITHOUT_DOCS_FLOW,
  HIS_CARE: HIS_CARE_CANCEL_FLOW,
  NON_HIS_CARE: NON_HIS_CARE_CANCEL_FLOW,
  CARE: CARE_CANCEL_FLOW,
  HIS: HIS_CANCEL_FLOW,
  NON_HIS: NON_HIS_CANCEL_FLOW,
  DEFAULT: CANCEL_FLOW,
};

export const POPOVER_DOWNLOAD_CONTENT = `Select a payer to download cashless<br />form, checklist form,<br />acknowledgement letter.`;

export const CASHLESS_DOWNLOAD_INFO = `Download cashless form, checklist form,<br />acknowledgement letter.`;

export const TPA_BANNER_TEXT = {
  UPLOAD_CLAIM_TOOL_TIP_TITLE: 'Upload Claims Data',
  WITH_IP_NUMBER: 'With IP Number and Running Bill Value',
  DOWNLOAD_OPEN_CLAIM_TOOL_TIP_TITLE: 'Download Open Claims',
  FOR_15_DAYS: 'For 15 days',
  SEARCH_RESULTS: 'Search Results',
  SHOWING_RESULTS: 'Showing results',
  BASED_ON_FILTER_SELECTED: 'based on filters selected and',
  FOR: 'for',
  WE_HAVE_FOUND: '. We have found',
  DOWNLOAD_FILTERED_CLAIMS_TOOL_TIP_TITLE: 'Download Filtered Claims',
  PRE_DOWNLOAD_FILTERED_CLAIMS_TOOL_TIP_CONTENT: 'Now you can download ',
  DOWNLOAD_FILTERED_CLAIMS_TOOL_TIP_CONTENT: 'Filtered claims ',
  POST_DOWNLOAD_FILTERED_CLAIMS_TOOL_TIP_CONTENT: 'by clicking download',
  INITIATE_SETLEMENT_TOOLTIP: 'Click to Initiate Settlement',
  FOLLOW_UP_REMINDER_TOOLTIP: 'Click to send Follow-Up Reminder',
  CANCEL_PA_TOOL_TIP_TITLE: 'Cancel PA ',
  CANCEL_PA_TOOL_TIP_CONTENT: 'You cancelling the un utilised PA will help other patients',
  CANCEL_TITLE: 'CANCEL CLAIM',
  DRAFT_PENDING: 'DRAFT_PENDING',
  DRAFT: 'DRAFT',
  PA_UTILIZATION_PENDING_TOOL_TIP_TITLE: 'Pending Cases to Utilise Since Start',
  PA_UTILIZATION_PENDING_TOOL_TIP_CONTENT: 'Please cancel un-utilised PA. An automated report will be sent to hospital CFO. ',
  LAST: 'Last',
  DAYS: ' days',
  DEFAULT_NO_OF_DAYS: 30,
  DOWNLOAD_FILTERED_CLAIM_URL: 'Provider/Claim/GetClaimstoDownload',
  THIRTY_DAYS: '30 days',

};

export const SUCCESS_AND_FAILURE_MESSAGES = {
  FILE_SUCCESSFULLY_DOWNLOADED: 'File Downloaded Successfully',

};

export const DATE_PICKER_CONSTANTS = {
  SELECT_ADMISSION_DATE: 'Select Admission Date',
  SELECT_DISCHARGE_DATE: 'Select Discharge Date',
  APPLY_THE_DATES: 'Apply the Dates',
  SELECT_RANGE_END_DATE: 'Select Range End Date',
  SELECT_RANGE_START_DATE: 'Select Range Start Date',
  ONE_YEAR_AGO: '365',
};

export const PRE_AUTH_VIEW = 'PreAuthView';
export const CLAIM_VIEW = 'ClaimView';

export const HOSPITAL_MAILBOX_CONGURATIONS = [
  { name: 'Gmail', value: 'gmailWithPass' },
  { name: 'Hotmail', value: 'hotmail' },
  { name: 'Outlook', value: 'outlook' },
  { name: 'Microsoft Exchange', value: 'microsoftExchange' },
  { name: 'SendGrid', value: 'sendGrid' },
  { name: 'Others', value: 'others' },
];

export const PASSWORD_TYPES = {
  gmailWithPass: 'SMTP',
  microsoftExchange: 'MSExchange',
  sendGrid: 'SendGrid',
  outlook: 'SMTP',
  hotmail: 'SMTP',
  others: 'SMTP',
};

export const CONFIGURATION_VALIDATIONS = {
  passwordValidation: 'Password is required!',
  sendGridValidation: 'Please enter this field!',
  sendGridAppKeyPlaceholder: 'Enter SendGrid App key',
  sendGridPasswordPlaceholder: 'Enter password for sendGrid',
  primaryMailIdPlaceholder: 'Enter your primary Email ID',
  primaryMailPasswordPlaceholder: 'Enter password for primary Email ID',
  primaryMailId: 'Primary Email is required!',
  primaryMailIdPattern: 'Please enter a valid Email ID!',
  configType: 'Client Email is required!',
  emailIdCharLimit: 'Email Id cannot be longer than 50 characters',
  fieldRequiredMessage: 'Please enter this field!',
  primaryMailIdCharValidation : 'Primary Email cannot be longer than 50 characters',
  passwordLimitValidation : 'Password cannot be longer than 50 characters',
  sendgridPasswordLimitValidation : 'Password cannot be longer than 70 characters',
  emailIdValidation: 'Email ID is Invalid!',
  invalidAndTooLongEmail: 'Email ID is invalid and cannot be longer than 50 characters',
  duplicateEmail: 'Duplicate Email ID',
};

export const KEYS_TO_HANDLE = {
  Enter: 'Enter',
};

export const PAYER_DROPDOWN_CONSTANTS = {
  ENABLED_PAYERS: 'Payers - Enabled',
  ENABLE_PENDING_PAYERS : 'Payers - Pending Enablement',
};

export const MAIL_CONFIGURATION_CONSTANTS = {
  EMPTY_STRING: 'Email cannot be empty',
};

export const TRACK_COURIER = 'courier-track';

export const HOSPITAL_SEAL_FILE_FORMAT = 'File format needs to be';

export const FILE_EXTENSION = ' .png, .jpg, .jpeg';

export const FILE_EXCEED_MESSAGE = '*File size cannot exceed 1MB';

export const HOSPITAL_MAX_FILE_SIZE = 1 * 1024 * 1024;

export const HOSPITAL_SEAL_SUPPORTED_FORMATS = {'fileFormats' : ['image/jpeg', 'image/png', 'image/jpg'], 'fileErrorMessage': 'Supported file formats are JPG, JPEG, PNG.'};

export const CASHLESS_FORM_CONSTANTS = {
  HOSPITAL_SEAL_UPLOAD: 'Please Upload your <b class="bolded">Hospital seal</b> to automatically capture it in <b class="bolded">Cashless Form</b>',
  FILE_NAME: 'Seal.png',
  HOSPITALSEAL: 'HospitalSeal',
  UPLOADED_ON: 'Uploaded on',
  ADD_HOSPITAL_SEAL: 'Add Hospital Seal',
  DATE_FORMAT: format(new Date(), 'dd MMM yyyy'),
  SIGNATURE: 'Signature.png',
};

export const MEMBER_AGE = /^[0-9]{1,3}$/;

export const MAX_AGE_LIMIT = 3;

export const fieldMappings: Record<string, string> = {
  fullName: 'memberName',
  emailId: 'memberEmailId',
  corporateName: 'policyHolderName',
  employeeId: 'employeeCode',
  policyNumber: 'policyNo',
  insurerName: 'insuranceCompanyName',
  memberGenderSex: 'memberGenderSexRadio',
};
export const DEFAULT_ADMISSION_TYPE = ['Planned', 'Emergency'];
export const KSRTC_ADMISSION_TYPE = ['IPD', 'OPD'];

export const GRIEVANCE_ACTIONS = {
  REOPEN: 'Reopen', QUERY: 'Query', NEW_GRIEVANCE:
    'Raise New Grievance', SUBMIT: 'Submit', BACK: 'Go Back',
};

export const DEFAULT_DATE_FILTER = ['All Dates'];

export const DATE_FILTER = 'dateFilter';

export const ALL_DATE_FILTERS = ['Last Modified', 'Claim Creation', 'DOA', 'DOD'];

export const SETTLEMENT_EMAIL_INFO = 'If settlement email IDs are not configured, IHX will use Pre-Authorisation email IDs for settlement transactions also.';

export const PRE_AUTH_EMAIL_CONFIG_TITLE = 'Configure Payer Email: Pre-Authorisation';

export const SETTLEMENT_EMAIL_CONFIG_TITLE = 'Configure Payer Email: Settlement';

export const USER_PRE_AUTH_EMAIL_CONFIG = `Enter payer multiple emails used for all transactions related to pre-authorisation separated by ',' and click Save.`;

export const USER_SETTLEMENT_EMAIL_CONFIG =  `Enter payer multiple emails used for all transactions related to settlement separated by ',' and click Save.`;

export const PAYER_EMAIL_PLACEHOLDER = 'Enter payer email';

export const CONFIG_EMAIL_ERROR = 'Error in onSavePreAuthEmail:';

export const EMAIL_MAX_LENGTH_ERROR = (maxLengthValue: number): any => `Each email cannot be longer than ${maxLengthValue} characters.`;

export interface ConfigurePayerEmailInterface {
  title: string;
  placeholder: string;
  description: string;
  emailKey: string;
  emails: string[];
  payerObj: any;
  onSave: () => void;
  onRemove: (email: string) => void;
  clearEmailField: () => void;
  handleKey: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}

export const CONFIGURE_EMAIL_FORM_KEYS = {
  preAuthEmail : 'configure-email',
  settlementEmail: 'configure-settlement-email',
};

export const TRIM_SPACE_REGEX = /,\s*/;

export const GRIEVANCE_DETAIL_ROUTE = '/grievance/view/detail/';

export const GRIEVANCE_RAISE_LIST_ROUTE = '/grievance/raise/list';

export const GRIEVANCE_VIEW_ROUTE = '/grievance/view';

export const REOPEN = 119;

export const TICKET_QUERY = 118;

export const NO_FILE_TEXT = 'No files to download';

export const FILE_UPLOAD_SUCCESS_TEXT = 'File uploaded successfully';

export const ENTER_GRIEVANCE_TYPE_MESSAGE = 'Please select Grievance Type';

export const ENTER_REMARKS_MESSAGE = 'Please enter Remarks';

export const SUCCESSFUL_TICKET_CREATION = 'Ticket created successfully';

export const GRIEVANCE_REMARKS_PLACEHOLDER = 'Enter your remarks here..';

export const GRIEVANCE_MAX_LIMIT_VALIDATION_MESSAGE = 'Remarks cannot exceed 500 characters';

export const GRIEVANCE_REMARKS_RQUIRED_MESSAGE = 'Remarks are required!';

export const GLOBAL_SEARCH_DROPDOWN_ITEMS = [
  { key: 'patientName', label: 'Patient Name' },
  { key: 'transactionId', label: 'UTR No.' },
  { key: 'payerClaimNo', label: 'Claim No.' },
];

export const HORIZONTAL_SCROLL_POPOVER = {
  HEADER: 'Scroll through the table',
  LEFT_TEXT: 'Click on arrow to move to the left',
  RIGHT_TEXT: 'Click on arrow to move to the right',
};
export const  GLOBAL_SEARCH_NULL_MESSAGE = 'Search text cannot be empty';

export const DEFAULT_TEXT = 'default';

export const INITIAL_INPATIENT_CASES_COUNT = {
  claimsCount: 0,
  secondaryClaimsCount: 0,
  };

export const PATIENT_CONSENT_LIST = [
  'I agree to allow the hospital to submit all original documents pertaining to hospitalization to the Insurer/TPA after the discharge. I agree to sign on the Final Bill & the Discharge Summary, before my discharge.',
  'Payment to hospital is governed by the terms and conditions of the policy. In case the Insurer / TPA is not liable to settle the hospital bill, I undertake to settle the bill as per the terms and conditions of the policy.',
  'All non-medical expenses and expenses not relevant to current hospitalization and the amounts over & above the limit authorized by the Insurer/TPA not governed by the terms and conditions of the policy will be paid by me.',
  'I hereby declare to abide by the terms and conditions of the policy and if at any time the facts disclosed by me are found to be false or incorrect, I forfeit my claim and agree to indemnify the insurer / TPA.',
  'I agree and understand that TPA is in no way warranting the service of the hospital & that the Insurer / TPA is in no way guaranteeing that the hospital services will be free from deficiencies.',
];

export const PATIENT_SIGNATURE_CONSTANTS = {
  PATIENT_NAME_PLACEHOLDER: 'Enter patient\'s or insured\'s name',
  INFORMED_VIA_CONSENT: 'Informed Consent Via Hospital',
  CONTACT_NUMBER_PLACEHOLDER: 'Please enter your contact number',
  FONTSIZEOPTIONS: ['23px'],
  FONTFAMILYOPTIONS: ['Handlee', 'Homemade Apple', 'Ms Madi', 'Kalam'],
  FONTFAMILYWEIGHT: ['300'],
  REFRESH_SIGNATURE_TEXT: 'Refresh Signature',
  DELETE_SIGNATURE_TEXT: 'Delete Signature',
  TIME_FORMAT: '00 : 00 PM / AM',
  REQUEST_CONSENT_SIGNATURE: 'Request Consent / Signature',
  PATIENT_INSURED_SIGNATURE: `Patient's / Insured's Signature`,
  TITLE: 'Patient / Representative Consent',
  PATIENT_SIGNATURE_OPTIONS: ['Upload Patient Signature', 'Informed Consent Via Hospital'],
  CONSENT_MODAL_TITLE: 'Consent Declaration from Patient / Insured',
  UPLOAD_TEXT: 'Please Scan and Upload Patient Signature',
  CONSENT_DISCLAIMER_TEXT: 'Please talk to the patient, check the box and proceed to submit the Pre-Auth Form',
  FILE_FORMAT: 'File format needs to be',
};

export const getPatientConsentDeclaration = (providerName: string): ReactElement => (
  <span className="patient-consent-declaration">
    &nbsp;I hereby agree to give consent to <b>{providerName}</b> to raise PA
    against my insurance policy and will be represented by an electronic
    signature.
  </span>
);

export const patientConsentAgreement = (providerName: string): ReactElement => (
  <span className="consent-agreement">
  &nbsp;I hereby agree to give consent to <b>
    {providerName}</b> to raise PA against my insurance policy
</span>
);

export const FILES_UPLOAD_SUCCESSFULL_TEXT = 'Files Uploaded Successfully';

export const FILE_FETCH_ERROR = 'Error occured, please try again.';

export const DISCHARGE_CONTEST_MESSAGE = 'Discharge Contest submitted successfully.';

export const getFlowName = (isDischargeContestCTA: boolean): string =>
  isDischargeContestCTA ? 'Please explain the contest in detail' : 'Remarks for document upload';

export const getPrefixforRemark = (isDischargeContestCTA: boolean): string =>
  isDischargeContestCTA ? 'Discharge Contest' : 'Remarks for document upload';

export const OTHER_KEY = 'others';

export const  PRE_AUTH_VIEW_DEFAULT_COLOR_RANGES: ColorRange[] = [
  { min: 0, max: 10800000, color: '#5A58DF' },
  { min: 10800001, max: 21600000, color: '#EC7637' },
  { min: 21600001, max: 43200000, color: '#EA4336' },
  { min: 43200001, max: Infinity, color: '#EA4336' },
];

export const CLAIM_VIEW_DEFAULT_COLOR_RANGES: ColorRange[] = [
    { min: 0, max: 259200000, color: '#5A58DF' },
    { min: 259200001, max: 518400000, color: '#EC7637' },
    { min: 518400001, max: 1036800000, color: '#EA4336' },
    { min: 1036800001, max: Infinity, color: '#EA4336' },
  ];

export const CV_DEFAULT_ELAPSED_TIME_DROPDOWN = ['0 - 1 day', '1 - 3 days', '3 - 6 days', '6 - 12 days', '>12 days']; // for claim view

export const PAV_DEFAULT_ELAPSED_TIME_DROPDOWN = ['0 - 3 hours', '3 - 6 hours', '6 - 12 hours', '>12 hours']; // for pre auth view

export const INPATIENT_FILTER_TITLE_MAP: Record<string, string> = {
  dateFilter: 'Date Filter',
  elapsedTime: 'Elapsed Time',
};

export const FOLLOW_CONSTANTS = {
  FOLLOW_UP_SUCCESS_MSG: 'Follow up email sent successfully.',
  FOLLOW_UP_FAILURE_MSG: 'Failed to send the follow-up email. Please try again later.',
  FOLLOW_UP_LOADING_MSG: 'This might take a few seconds. Please wait.',

};

export const PRE_AUTH_CONFIGS_TO_BE_REMOVED  = ['ACTIONS', 'utrNo', 'COURIER_STATUS', 'Elapsed_Time'];

export const PRE_AUTH_CONFIGS_TO_BE_REMOVED_NEW_TPA = ['utrNo', 'COURIER_STATUS'];

export const DEFAULT_TABLE_CONFIGS  = ['ACTIONS', 'Elapsed_Time'];

export const CLAIM_VIEW_CONFIGS_TO_BE_REMOVED = ['Elapsed_Time'];

export const DATE_FORMAT_TO_PARSE = [
  'dd MMM yyyy, HH:mm:ss',  // 13 May 2025, 07:48:07
  'dd MMM yyyy, hh:mm a',    // 13 May 2025, 07:48 AM
];

export const PROVIDER_SPECIFIC_FEATURES = {
  IsIpNoMandatory: 'IsIpNoMandatory',
};

export const defaultPostParams = {
  defaultConfig: undefined,
  defaultHeaders: undefined,
  defaultIsProviderInfoRequired: undefined,
  defaultIsBadRequest: undefined,
};

export const CANCELLATION_STATUS_ID = '13';

export const FALL_BACK_CANCEL_MODAL_NAME = 'Claim Cancellation';

export const CANCELLATION_SUCCESSFUL_MESSAGE = 'Claim cancellation successful.';

export const CANCELLATION_FAILURE_MESSAGE = 'Unable to cancel claim.';

export const CANCEL_TEXT = 'CANCEL';

export const FUNDED_CLAIMS_TYPES = ['corporate-funded-claims', 'government-funded-claims'];

export const REMOVE_ALL_WHITESPACE_REGEX = /\s+/g;

export const TIME_12H_FORMAT_REGEX = /^(\d{1,2})(?::?(\d{2}))?(AM|PM)$/i;

export const WEEK_DAYS = [
  { day: 'M', fullName: 'Monday' },
  { day: 'T', fullName: 'Tuesday' },
  { day: 'W', fullName: 'Wednesday' },
  { day: 'T', fullName: 'Thursday' },
  { day: 'F', fullName: 'Friday' },
  { day: 'S', fullName: 'Saturday' },
  { day: 'S', fullName: 'Sunday' },
];

export const GOOGLE_AUTH = 'GoogleAuth';

export const DR_AGARWAL_CONST = {
  ORIGIN: 'dragarwal',
  DOMAIN: 'dragarwal.com',
};

// Constants for Google OAuth configuration
export const GOOGLE_OAUTH_CONSTANTS = {
  GOOGLE_LOGIN: 'Continue with Google',
  ENDPOINTS: {
    AUTHORIZATION: 'https://accounts.google.com/o/oauth2/v2/auth',
    TOKEN: 'https://oauth2.googleapis.com/token',
  },
  STORAGE_KEYS: {
    NONCE: 'google_oauth_nonce',
    DEEPLINK: 'deeplink_destination',
    ORIGINAL_DEEPLINK: 'original_deeplink_path',
    INTERACTIVE_LOGIN: 'google_interactive_login',
  },
  SCOPES: {
    DEFAULT: ['openid', 'profile', 'email'],
  },
  ERRORS: {
    MISSING_CLIENT_ID: 'Google OAuth Client ID is not configured',
    INVALID_STATE: 'Invalid state parameter - possible CSRF attack',
    AUTHENTICATION: ' Google Authentication failed.',
    AUTHENTICATION_RESPONSE: 'No authentication response found',
    ALLOWED_DOMAIN: 'Unauthorized access from external domain. Please log in.',
    UNKNOWN: 'Unknown error',
    START_G_AUTH: 'Failed to start Google Authentication',
  },
};

export const DEEPLINK_CONSTANTS = {
  ERRORS: {
    HOSPACTION_ID: 'Claim Reference ID is required',
    PROVIDER_ID: 'Provider info is not available',
  },
};

export const ALLOWED_AUTH_DOMAINS = [DR_AGARWAL_CONST.DOMAIN];

export const PATH_URLS = {
  INPATIENT_ROOT: '/claims/in-patient',
  NEW_ADMISSION: '/new-admission',
  CLAIM_DETAIL: '/detail',
};

export const POSSIBLE_NONCE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

export const DUMMY_PAYER_ID = '99999';

export const BUDDHIMED_BTN_TEXT = { 'PRINT': 'Print All', 'DOWNLOAD': 'Download All' };

export const MAX_CHARACTERS_LENGTH_LIMIT = 50;

export const EMAIL_CHARACTER_LIMIT = 40;

export const tableConfigKeyMap: Record<string, string> = {
    reportingTransactionConfigList: 'ReportingSearchParamList',
    claimsDisplay: 'ClaimsDisplayParamList',
    reconciliation: 'ReconciliationSelectedColumns',
    grievance: 'InPatientSearchParamList',
    viewGrievance: 'GrievanceSearchParamList',
    preAuthView: 'PreAuthViewSearchParamList',
    claimView: 'ClaimViewSearchParamList',
    inPatient: 'InPatientSearchParamList',
    reportingTATConfigList: 'ReportingTATConfigList',
  };
export const SURVEY_CONSTANTS = {
  SUCCESS_TEXT: 'Thank you for your response!',
  SURVEY_SUCCESS_MESSAGE: 'Thank you for your interest. Our team will also get in touch with you shortly. You can refer to the Resource Section for the configuration procedure',
  RESOURCE_LINK_TEXT: 'Resource Section',
  RESOURCE_LINK_HREF: '/resources/help',
  SUBMIT: 'Submit',
  REMIND_LATER: 'Remind me later',
  FEEDBACK_TEXT: 'Your feedback matters to us',
  HOSPITAL_SURVEY: 'Hospital Software Survey',
};
